import { render, staticRenderFns } from "./Infobar.vue?vue&type=template&id=91495034"
import script from "./Infobar.vue?vue&type=script&lang=js"
export * from "./Infobar.vue?vue&type=script&lang=js"
import style0 from "./Infobar.vue?vue&type=style&index=0&id=91495034&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports